import angular from 'angular';
import config from './realizations.config';

import {Realizations} from './realizations-by-employee/realizations-by-employee.component';
import {RealizationsByGroup} from './realizations-by-group/realizations-by-group.component';
import {RealizationsByTeacher} from './realizations-by-teacher/realizations-by-teacher.component';
import {AddRealization} from './add-realization/add-realization.component';
import {AddSubstitutionRealization} from './add-substitution-realization/add-substitution-realization.component';
import {EditRealization} from './edit-realization/edit-realization.component';
import {EditSubstitutionRealization} from './edit-substitution-realization/edit-substitution-realization.component';

import RealizationsController from './realizations.controller.js';
import ViewStudentsController from './view-students/view-students.controller';
import SelectSubstitutionActivityController from './select-substitution-activity/select-substitution-activity.controller';

import './realizations.scss';

/**
 * @desc  Module initialize.
 *
 * @ngInject
 */
export default angular
  .module('app.modules.realizations', [])
  .component('realizationsComponent', Realizations)
  .component('realizationsByGroupComponent', RealizationsByGroup)
  .component('realizationsByTeacherComponent', RealizationsByTeacher)
  .component('addRealizationComponent', AddRealization)
  .component('addSubstitutionRealizationComponent', AddSubstitutionRealization)
  .component('editRealizationComponent', EditRealization)
  .component('editSubstitutionRealizationComponent', EditSubstitutionRealization)
  .controller('ViewStudentsController', ViewStudentsController)
  .controller('RealizationsController', RealizationsController)
  .controller('SelectSubstitutionActivityController', SelectSubstitutionActivityController)
  .config(config)
  .name;
